import { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
import { Stack } from 'react-bootstrap';
import ConfirmationModal from '../../../components/modals/ConfirmationModal';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { useToast } from '../../../context/ToastContext';
import { userCanEditCreateDelete_Allergies } from '../../../features/dash/views/people/Allergy/AllergiesView';
import { useDeleteAllergyMutation } from '../../../services/endpoints/people/allergy';
import { Allergy } from '../../../services/endpoints/people/user';
import { getCurrentUser } from '../../../services/helper';
import { getErrorMessage } from '../../utils';

const DeleteAllergyButton: React.FC<{ id: number }> = ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const [deleteAllergy, { isLoading }] = useDeleteAllergyMutation();
  const { addToast } = useToast();

  const handleDelete = async () => {
    try {
      await deleteAllergy(id).unwrap();
      addToast('Allergy deleted successfully', 'success');
      setShowModal(false);
    } catch (e) {
      addToast(getErrorMessage(e), 'error');
    }
  };

  return (
    <>
      <button
        className="text-info fw-bolder btn btn-link p-0"
        style={{ fontSize: '.875rem', textDecoration: 'underline' }}
        onClick={() => setShowModal(true)}
      >
        Delete
      </button>
      <ConfirmationModal
        show={showModal}
        title="Delete Allergy"
        message="Are you sure you want to delete this allergy?"
        confirmText="Yes, Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setShowModal(false)}
        isLoading={isLoading}
      />
    </>
  );
};

const currentUser = getCurrentUser();
export const allergyColumns: ColumnDef<Allergy>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
    cell: ({ getValue }) => (
      <LinkCell
        content={getValue<number>()}
        url={`/admin/allergies/${getValue<number>()}`}
        state={{ returnTo: '/admin/allergies' }}
      />
    )
  },
  {
    header: 'Child',
    accessorKey: 'child.full_name',
    cell: ({ row }) => (
      <LinkCell
        content={row.original.child?.full_name}
        url={`/admin/sfc-users/children/${row.original.child?.id}`}
      />
    )
  },
  {
    header: 'Allergy',
    accessorKey: 'allergy'
  },
  {
    header: 'Details',
    accessorKey: 'details'
  },
  {
    header: () => null,
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => (
      <Stack
        direction="horizontal"
        gap={2}
      >
        <LinkCell
          content="View"
          url={`/admin/allergies/${row.original.id}`}
          underline
          state={{ returnTo: '/admin/allergies' }}
        />
        {userCanEditCreateDelete_Allergies(currentUser) && (
          <>
            <LinkCell
              content="Edit"
              url={`/admin/allergies/${row.original.id}/edit`}
              underline
            />
            <DeleteAllergyButton id={row.original.id!} />
          </>
        )}
      </Stack>
    )
  }
];
